import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';

import MemberCard from '../member-card';
import DisabledOverlay from '../../../components/purchase-dashboard/disabled-overlay';
import Title from '../../title';
import iconEnvelope from '../../../img/icon-envelope.svg';

class Contributors extends Component {
  constructor(props) {
    super(props);
    this.onInvitePeople = this.onInvitePeople.bind(this);
  }

  onInvitePeople() {
    if (this.props.userLoggedIn) {
      this.props.onInvitePeople();
    } else {
      this.props.onCantInvitePeople();
    }
  }

  showOrganizerActions() {
    return this.props.renderOrgActions;
  }

  renderHeading() {
    return (
      <div className="purchase-contributors-heading">
        <Title
          text={
            <FormattedMessage
              id="contributors.title"
              defaultMessage="Contributors"
            />
          }
          name="contributors"
          bigger
          divider
        />
        <div className="heading pt-4">
          <p className="cool-grey">
            <FormattedMessage
              id="contributors.subtitle"
              defaultMessage="People who already contributed to the group, don't let them down."
            />
          </p>
        </div>
      </div>
    );
  }

  renderMemberCardAsOrganizer(membership) {
    return (
      <MemberCard
        onRemoveMember={this.props.onRemoveMember}
        membership={membership}
        payments={this.props.payments}
        showActions={this.showOrganizerActions()}
        viewAs="organizer"
      />
    );
  }

  renderMemberCardAsInvitee(membership) {
    return (
      <MemberCard
        membership={membership}
        payments={this.props.payments}
        showActions={false}
        viewAs="invitee"
      />
    );
  }

  renderInvitePeople() {
    return (
      <div className="invite-people-card col-lg-4 col-md-12" key="invite-people-card">
        <div className="invite-people card pt-4">
          <a href="#invite-people" onClick={this.onInvitePeople}>
            <div className="row">
              <div className="col-4">
                <div className="oval text-center rounded-circle">
                  <img alt="invite-people" src={iconEnvelope} />
                </div>
              </div>
              <div className="col-8 pt-2">
                <FormattedMessage
                  id="contributors.sendInvites"
                  defaultMessage="Send Invites"
                />
              </div>
            </div>
          </a>
        </div>
      </div>
    );
  }

  renderMemberCards() {
    const { asOrganizer } = this.props;
    const cards = this.props.memberships.map((member) => {
      const key = `member-card-${member.id}`;
      return (
        <div className="contributor-card col-lg-4 col-md-12" key={key}>
          { asOrganizer ? this.renderMemberCardAsOrganizer(member) : this.renderMemberCardAsInvitee(member) }
        </div>
      );
    });

    return (
      <div className="cards row">
        {cards}
        {this.renderInvitePeople()}
      </div>
    );
  }

  renderDisableOverlay() {
    if (this.props.disable) return <DisabledOverlay />;
  }

  render() {
    return (
      <div className="purchase-contributors container">
        <div className="container">
          {this.renderHeading()}
          {this.renderMemberCards()}
        </div>
        {this.renderDisableOverlay()}
      </div>
    );
  }
}

export default Contributors;



// WEBPACK FOOTER //
// ./src/desktop/components/purchase-dashboard/contributors/contributors.js